module.exports = __webpack_public_path__ + "static/media/logo_mailer.f1b2bffb.svg";